import Dexie, { Table } from "dexie";

import { PayoutOrdersDownload_storeOrdersPayout_edges_node } from "./reports/PayoutOrders/types/PayoutOrdersDownload";

export interface ReportPayoutOrders
  extends PayoutOrdersDownload_storeOrdersPayout_edges_node {
  download_date: string | null;
}

export class SubClassedDexie extends Dexie {
  payoutOrders!: Table<ReportPayoutOrders>;

  constructor() {
    super("WebtoolDatabase");
    this.version(1).stores({
      payoutOrders: "store_order_code, download_date, order_code"
    });
  }
}

export const db = new SubClassedDexie();
